import { getCheckout as getCheckoutHttp } from '@wix/ambassador-ecom-v1-checkout/http';
import { GetCheckoutResponse } from '@wix/ambassador-ecom-v1-checkout/types';
import { Transactions } from '../monitoring/transactions';
import { ControllerFlowAPI } from '../types/types';
import { SPECS } from '../consts';

export interface GetCheckoutInfoArgs {
  checkoutId: string;
  currency?: string;
}
export class GetCheckoutApi {
  private readonly flowAPI: ControllerFlowAPI;

  constructor({ flowAPI }: { flowAPI: ControllerFlowAPI }) {
    this.flowAPI = flowAPI;
  }

  async getCheckout({
    checkoutId,
    currency,
  }: GetCheckoutInfoArgs): Promise<GetCheckoutResponse> {
    const shouldUseErrorHandler = this.flowAPI.experiments?.enabled?.(
      SPECS.ShouldUseErrorHandler,
    );

    const shouldAddWixCurrencyHeader = this.flowAPI.experiments.enabled(
      SPECS.CheckPaymentCurrency,
    );
    this.flowAPI.panoramaClient?.transaction(Transactions.GetCheckout).start();

    const response = shouldUseErrorHandler
      ? await this.flowAPI.errorHandler.withErrorHandler(
          () =>
            this.flowAPI.httpClient.request((args) => ({
              ...getCheckoutHttp({ id: checkoutId })(args),
              ...(shouldAddWixCurrencyHeader && currency
                ? { headers: { 'x-wix-currency': currency } }
                : {}),
            })),
          {
            errorCodesMap: {},
          },
        )
      : await this.flowAPI.httpClient.request((args) => ({
          ...getCheckoutHttp({ id: checkoutId })(args),
          ...(shouldAddWixCurrencyHeader && currency
            ? { headers: { 'x-wix-currency': currency } }
            : /* istanbul ignore next */ {}),
        }));
    this.flowAPI.panoramaClient?.transaction(Transactions.GetCheckout).finish();

    return response.data;
  }
}
